import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';

import {
  COOKIE_AD_PERSONALIZATION,
  COOKIE_AD_STORAGE,
  COOKIE_AD_USER_DATA,
  COOKIE_ANALYTICS_STORAGE,
  COOKIE_SETUP,
  COOKIE_VALUE_DENIED,
  COOKIE_VALUE_GRANTED,
  ENDPOINT_ROOT,
  ENDPOINT_UPDATE_COOKIE_ACCEPTANCE,
  ENDPOINT_USERS,
  ROUTE_LEGALS,
  ROUTE_LOGIN,
  ROUTE_SCANBAT,
} from '@/common/constants';
import CookiesAnalytics from '@/common/services/Cookies.analytics';
import { TAG_MANAGER } from '@/ebat/constants';
import useCookie from '@/ebat/hooks/cookie/useCookie';

import { useAuth } from '../contexts/AuthContext';
import { useModalContext } from '../contexts/ModalContext';
import { useTagManager } from '../contexts/TagManagerContext';

const withCookiesBannerLogic = (CookiesBanner) => ({
  /* eslint-disable react/prop-types */
  children,
  /* eslint-enable react/prop-types */
}) => {
  const location = useLocation();
  const [hasCookies, setHasCookies] = useState(
    CookiesAnalytics.getCookie(COOKIE_SETUP) === '1',
  );

  const { cookieModalIsOpen, setCookieModalIsOpen } = useModalContext();

  const { onPushEvent } = useTagManager();
  const { user } = useAuth();
  const endPoint = [
    `${ENDPOINT_ROOT}/${ENDPOINT_USERS}/${ENDPOINT_UPDATE_COOKIE_ACCEPTANCE}`,
  ];

  const { mutate: mutatePutCookie } = useCookie([endPoint]);

  useEffect(() => {
    if (!CookiesAnalytics.getCookie(COOKIE_AD_PERSONALIZATION)) {
      CookiesAnalytics.setCookie(
        COOKIE_AD_PERSONALIZATION,
        COOKIE_VALUE_DENIED,
      );
    }
    if (!CookiesAnalytics.getCookie(COOKIE_AD_STORAGE)) {
      CookiesAnalytics.setCookie(COOKIE_AD_STORAGE, COOKIE_VALUE_DENIED);
    }
    if (!CookiesAnalytics.getCookie(COOKIE_AD_USER_DATA)) {
      CookiesAnalytics.setCookie(COOKIE_AD_USER_DATA, COOKIE_VALUE_DENIED);
    }
    if (!CookiesAnalytics.getCookie(COOKIE_ANALYTICS_STORAGE)) {
      CookiesAnalytics.setCookie(COOKIE_ANALYTICS_STORAGE, COOKIE_VALUE_DENIED);
    }
  }, []);

  /**
   * Désole pour ça, je sais que c'est illegal, ce n'est pas faute de l'avoir dit, mais apriori tout le monde s'en fout
   */
  const handleSameAction = () => {
    CookiesAnalytics.setCookie(COOKIE_SETUP, '1');
    setHasCookies(true);
  };

  const handleSubmit = (isSelectedPerformance) => {
    handleSameAction();
    if (isSelectedPerformance) {
      CookiesAnalytics.setCookie(
        COOKIE_ANALYTICS_STORAGE,
        COOKIE_VALUE_GRANTED,
      );
    }
    onPushEvent({
      event: TAG_MANAGER.EVENTS.CTA_COOKIE_CONSENT,
      [COOKIE_ANALYTICS_STORAGE]: COOKIE_VALUE_GRANTED,
      [COOKIE_AD_STORAGE]: CookiesAnalytics.getCookie(COOKIE_AD_STORAGE),
      [COOKIE_AD_USER_DATA]: CookiesAnalytics.getCookie(COOKIE_AD_USER_DATA),
      [COOKIE_AD_PERSONALIZATION]: CookiesAnalytics.getCookie(
        COOKIE_AD_PERSONALIZATION,
      ),
    });
    if (location.pathname !== ROUTE_LOGIN) {
      mutatePutCookie({
        isCookieAcceptance: true,
      });
    }
    setCookieModalIsOpen(false);
  };

  const handleRejectAll = (closeModal = true) => {
    handleSameAction();
    onPushEvent({
      event: TAG_MANAGER.EVENTS.CTA_COOKIE_CONSENT,
      [COOKIE_ANALYTICS_STORAGE]: COOKIE_VALUE_GRANTED,
      [COOKIE_AD_STORAGE]: COOKIE_VALUE_DENIED,
      [COOKIE_AD_USER_DATA]: COOKIE_VALUE_DENIED,
      [COOKIE_AD_PERSONALIZATION]: COOKIE_VALUE_DENIED,
    });

    if (location.pathname !== ROUTE_LOGIN) {
      mutatePutCookie({
        isCookieAcceptance: false,
      });
    }
    if (closeModal) {
      setCookieModalIsOpen(false);
    }
  };

  const handleAcceptAll = () => {
    CookiesAnalytics.setCookie(COOKIE_AD_PERSONALIZATION, COOKIE_VALUE_GRANTED);
    CookiesAnalytics.setCookie(COOKIE_AD_STORAGE, COOKIE_VALUE_GRANTED);
    CookiesAnalytics.setCookie(COOKIE_AD_USER_DATA, COOKIE_VALUE_GRANTED);
    CookiesAnalytics.setCookie(COOKIE_ANALYTICS_STORAGE, COOKIE_VALUE_GRANTED);
    handleSameAction();
    onPushEvent({
      event: TAG_MANAGER.EVENTS.CTA_COOKIE_CONSENT,
      [COOKIE_ANALYTICS_STORAGE]: COOKIE_VALUE_GRANTED,
      [COOKIE_AD_STORAGE]: COOKIE_VALUE_GRANTED,
      [COOKIE_AD_USER_DATA]: COOKIE_VALUE_GRANTED,
      [COOKIE_AD_PERSONALIZATION]: COOKIE_VALUE_GRANTED,
    });

    if (location.pathname !== ROUTE_LOGIN) {
      mutatePutCookie({
        isCookieAcceptance: true,
      });
    }
    setCookieModalIsOpen(false);
  };

  const isWebView = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // iOS detection
    const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
    const isIOSWebView =
      isIOS && !navigator.standalone && !/Safari/.test(userAgent);

    // Android detection
    const isAndroid = /Android/.test(userAgent);
    const isAndroidWebView = isAndroid && /\bwv\b/.test(userAgent);

    return isIOSWebView || isAndroidWebView;
  };

  return (
    <CookiesBanner
      isOpen={
        (isWebView()
          ? !user?.is_cookie_acceptance
          : !hasCookies &&
            location.pathname !== ROUTE_LEGALS &&
            location.pathname !== ROUTE_SCANBAT) || cookieModalIsOpen === true
      }
      onSubmit={handleSubmit}
      onAcceptAll={handleAcceptAll}
      onRejectAll={handleRejectAll}
    >
      {children}
    </CookiesBanner>
  );
};

export default withCookiesBannerLogic;
